var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadConfigIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.33464 10.666V5.23268L5.6013 6.96602L4.66797 5.99935L8.0013 2.66602L11.3346 5.99935L10.4013 6.96602L8.66797 5.23268V10.666H7.33464ZM4.0013 13.3327C3.63464 13.3327 3.32086 13.2022 3.05997 12.9413C2.79908 12.6805 2.66841 12.3665 2.66797 11.9993V9.99935H4.0013V11.9993H12.0013V9.99935H13.3346V11.9993C13.3346 12.366 13.2042 12.68 12.9433 12.9413C12.6824 13.2027 12.3684 13.3331 12.0013 13.3327H4.0013Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadConfigIcon);
export default __webpack_public_path__ + "static/media/upload_config_icon.61d0db44b6e12b4e4440781bf0ed4689.svg";
export { ForwardRef as ReactComponent };